module.exports = __webpack_public_path__ + "static/img/huan-zai-jin-2.1fef333.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/huan-zai-jin-2.jpeg
// module id = I9CK
// module chunks = 1